<div
    class="form-group row"
    style="margin-bottom: 0">
    <label class="col-sm-4 control-label col-form-label">After Process Message</label>
    <select
        [formControl]="preferencesForm().get('afterProcessMessage')"
        name="afterProcessMessage"
        class="form-select col-sm-6">
        <option value="DoNothing">Do Nothing</option>
        <option value="ReturnToIntake">Return to Intake</option>
    </select>
    <span
        [kno2Popover]="afterProcessMessageTooltip"
        class="ms-3">
        <i class="fa fa-info-circle box-info"></i>
    </span>
</div>
